import { requestApi } from '~/services/api.js';

const API_BASE_PATH = process.env.API_BASE_PATH || '';
const updateFirstNameLastname = async payload => {
	try {
		const response = await requestApi(`${API_BASE_PATH}/player/checkin/update`, payload, 'POST');
		return response;
	} catch (e) {
		return null;
	}
};
const checkinVerification = async payload => {
	try {
		const response = await requestApi(`${API_BASE_PATH}/player/checkin/verify`, payload, 'POST');
		return response;
	} catch (e) {
		return {
			errorCode: 'ERROR_MESSAGE_VERIFICATION_FAILURE',
			status: 'FAILURE'
		};
	}
};

const checkinPendingStatusApi = async playerId => {
	try {
		const response = await requestApi(`${API_BASE_PATH}/player/checkin/status?playerId=${playerId}`);
		return response;
	} catch (e) {
		return {
			errorCode: 'ERROR_ON_CHECKIN_PENDING_STATUS_API',
			status: 'FAILURE'
		};
	}
};

const checkinUpdateNotification = async encryptedPlayerIdPayload => {
	try {
		const response = await requestApi(
			`${API_BASE_PATH}/player/notification/checkin/setInactive`,
			encryptedPlayerIdPayload,
			'POST'
		);
		return response;
	} catch (e) {
		return null;
	}
};
export { updateFirstNameLastname, checkinVerification, checkinPendingStatusApi, checkinUpdateNotification };
